@let mobile = appNavigationFlags().mobileNavigation$();
@let showNavigation = appNavigationFlags().showNavigation$();
@let expanded = showNavigation && ((appNavigationFlags().pinned$() && !appNavigationFlags().disablePinning$()) || appNavigationFlags().hovered$() || mobile);

<div class="app-navigation-container" data-link-ga-root="AppNavigation" [class.impersonation]="model.impersonation$()">
  <div class="header" *ngIf="!mobile">
    <div class="logo">
      <div class="logo-icon">
        <img src="./assets/img/logos/see-circle-logo.png" />
      </div>
      <div class="logo-title" *ngIf="expanded">
        <img src="./assets/img/logos/see-title-logo.png" />
      </div>
    </div>
    <div class="pin" data-link-ga-node="Pin" [class.pin-active]="appNavigationFlags().pinned$()" *ngIf="expanded && !appNavigationFlags().disablePinning$()" (click)="togglePin()">
      <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.0863 7.25195L11.4719 15.2195C11.4363 15.7121 11.1723 16.1641 10.766 16.4383C9.39492 17.3676 8.36406 18.7844 7.94258 20.4805L7.62266 21.75H14.9352V16.875C14.9352 16.4281 15.3008 16.0625 15.7477 16.0625C16.1945 16.0625 16.5602 16.4281 16.5602 16.875V21.75H23.8727L23.5578 20.4805C23.1363 18.7844 22.1055 17.3676 20.7344 16.4383C20.323 16.159 20.0641 15.7121 20.0285 15.2195L19.409 7.25195C19.4039 7.21133 19.4039 7.1707 19.4039 7.125H12.0914C12.0914 7.16562 12.0914 7.20625 12.0863 7.25195ZM14.9352 23.375H7.62266C7.11992 23.375 6.64766 23.1465 6.34297 22.7504C6.03828 22.3543 5.92656 21.8414 6.04844 21.3539L6.36328 20.0844C6.88633 17.9871 8.16094 16.2402 9.85195 15.0926L10.3395 8.75L10.4664 7.125H9.24766C9.10039 7.125 8.96328 7.08437 8.84648 7.01836C8.59766 6.87617 8.43516 6.61211 8.43516 6.3125C8.43516 5.86562 8.80078 5.5 9.24766 5.5H10.4664H21.0289H22.2477C22.6945 5.5 23.0602 5.86562 23.0602 6.3125C23.0602 6.61211 22.8977 6.87617 22.6488 7.01836C22.532 7.08437 22.3949 7.125 22.2477 7.125H21.0289L21.1559 8.75L21.6434 15.0926C23.3344 16.2402 24.609 17.9922 25.132 20.0844L25.4469 21.3539C25.5688 21.8414 25.457 22.3543 25.1523 22.7504C24.8477 23.1465 24.3703 23.375 23.8727 23.375H16.5602V27.6875C16.5602 28.1344 16.1945 28.5 15.7477 28.5C15.3008 28.5 14.9352 28.1344 14.9352 27.6875V23.375Z" fill="#ECECEB"/>
      </svg>
    </div>
  </div>

  <div class="header" data-link-ga-node="Close" *ngIf="mobile" (click)="deactivateMenu()">
    <div class="logo"></div>
    <div class="close-icon-container">
      <i class="pi pi-times"></i>
    </div>
  </div>

  <div class="menu-container" data-link-ga-node="Menu">
    @for(menuItem of model.menuItems$(); track menuItem.id) {
      <ng-container *ngTemplateOutlet="menuItemTemplate; context: {menuItem: menuItem}"></ng-container>
    }
  </div>

  <div class="footer">
    <div class="logo" [style.visibility]="expanded ? 'visible' : 'hidden'">
      <div class="logo-title">
        <img src="./assets/img/logos/smartservice-logo.png" />
      </div>
    </div>

    <div class="time-label" [class.expanded]="expanded">
      {{model.displayTimestamp$()}}
    </div>

    <div class="app-info" *ngIf="expanded && showAppInfo">
      {{appInfo}}
    </div>
  </div>
</div>

<ng-template #menuItemTemplate let-menuItem="menuItem">
  @if(menuItem.type === 'separator') {
    <div class="separator"></div>
  }
  @else if(menuItem.type === 'user-profile') {
    <div class="menu-item" data-link-ga-node="UserProfile" [class.active]="menuItem.active" [class.expanded]="expanded" (click)="menuItemClicked(menuItem, $event)">
      <div class="menu-item-display">
        <div class="menu-item-icon" *ngIf="!model.impersonation$()" style="width: 26px">
          <link-user-avatar [size]="26"></link-user-avatar>
        </div>
        <div class="menu-item-icon" *ngIf="model.impersonation$()" style="font-size: 24px">
          <i class="pi pi-users"></i>
        </div>
        <div class="menu-item-label" *ngIf="expanded">
          {{model.displayName$()}}
        </div>
      </div>
    </div>
  }
  @else {
    <div class="menu-item" [attr.data-link-ga-node]="menuItem.id" [class.active]="menuItem.active" [class.expanded]="expanded" (click)="menuItemClicked(menuItem, $event)">
      <div class="menu-item-display">
        <div class="menu-item-icon">
          <img [src]="menuItem.iconPath" />
        </div>
        <div class="menu-item-label" *ngIf="expanded">
          {{menuItem.textToken | translate}}
        </div>
      </div>

      <div *ngIf="menuItem.type === 'parent-item' && expanded" class="menu-item-chevron">
        <i class="pi" [class.pi-chevron-down]="menuItem.expanded === false" [class.pi-chevron-up]="menuItem.expanded === true"></i>
      </div>
    </div>

    @if(menuItem.type === 'parent-item' && menuItem.children.length > 0 && menuItem.expanded) {
      <div class="child-menu-container" [class.expanded]="expanded">
        @for(childMenuItem of menuItem.children; track childMenuItem.id) {
          <ng-container *ngTemplateOutlet="menuItemTemplate; context: {menuItem: childMenuItem}"></ng-container>
        }
      </div>
    }
  }
</ng-template>
